export { cardVariables as cardBodyVariables } from './cardVariables';
